import { create } from 'zustand';

export interface NavigationState {
  // 当前焦点的 focusKey
  currentFocusKey: string | null;
  setCurrentFocusKey: (key: string | null) => void;

  // 焦点历史记录
  focusHistory: string[];
  addToHistory: (key: string) => void;
  clearHistory: () => void;

  // 导航路径
  currentPath: string;
  setCurrentPath: (path: string) => void;

  // 路由历史记录
  routeHistory: string[];
  addToRouteHistory: (path: string) => void;
  goBack: () => string | null; // 返回上一路由，如果没有历史则返回 null
  canGoBack: () => boolean;
  clearRouteHistory: () => void;
}

export const useNavigationStore = create<NavigationState>((set, get) => ({
  currentFocusKey: null,
  focusHistory: [],
  currentPath: '/',
  routeHistory: [],

  setCurrentFocusKey: (key) => set({ currentFocusKey: key }),

  addToHistory: (key) =>
    set((state) => ({
      focusHistory: [...state.focusHistory, key].slice(-20), // 保留最近20条
    })),

  clearHistory: () => set({ focusHistory: [] }),

  setCurrentPath: (path) => set({ currentPath: path }),

  addToRouteHistory: (path) =>
    set((state) => {
      // 如果路径与历史记录的最后一条相同，不添加（避免重复）
      if (state.routeHistory.length > 0 && state.routeHistory[state.routeHistory.length - 1] === path) {
        return state;
      }
      // 添加路径到历史记录（包括首页），保留最近50条
      // 这样从首页到其他页面时，首页会被记录，回退时可以回到首页
      return {
        routeHistory: [...state.routeHistory, path].slice(-50),
      };
    }),

  goBack: () => {
    const state = get();
    if (state.routeHistory.length === 0) {
      // 没有历史记录，返回 null 表示无法回退（应在首页）
      return null;
    }
    // 获取上一路由（历史记录的最后一条）
    const previousPath = state.routeHistory[state.routeHistory.length - 1];
    // 从历史记录中移除最后一条
    set({
      routeHistory: state.routeHistory.slice(0, -1),
    });
    return previousPath;
  },

  canGoBack: () => {
    const state = get();
    return state.routeHistory.length > 0;
  },

  clearRouteHistory: () => set({ routeHistory: [] }),
}));
